import { computed, Injectable, Signal } from '@angular/core';
import { Store } from '@ngrx/store';
import { BehaviorSubject, Subject } from 'rxjs';
import { TReducerState } from '../../../app.config';

@Injectable()
export class PageViewAndEditModeSwitchManager {
  public readonly mode: BehaviorSubject<'edit' | 'view'> = new BehaviorSubject<'edit' | 'view'>('view');
  public readonly isLockedInView: Signal<boolean>;

  public readonly addClicked = new Subject<void>();
  public readonly saveClicked = new Subject<void>();
  public readonly cancelClicked = new Subject<void>();

  constructor(private readonly globalStore: Store<TReducerState>) {
    const isCurrentUserAdmin = this.globalStore.selectSignal(
      ({ dashboardContent }) => dashboardContent.dashboardData?.isCurrentUserAdmin,
    );

    this.isLockedInView = computed(() => !isCurrentUserAdmin());
  }
}
